import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { CSSProperties } from 'react'
import Anchor from 'builder/components/Anchor'
import Card from './Card'
import { CardComponentProps } from './types'

type SortableCardProps = CardComponentProps & {
  sortId: number | string
  CardComponent: (typeof Card)[keyof typeof Card]
}

export const SortableCard = (props: SortableCardProps) => {
  const { sortId, CardComponent } = props

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: sortId,
  })

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform ? { ...transform, scaleX: 1, scaleY: 1 } : null),
    transition,
    position: 'relative',
    zIndex: isDragging ? 1 : undefined,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <Anchor id={sortId}>
        <CardComponent {...props} isDragging={isDragging} dragHandleListeners={listeners} />
      </Anchor>
    </div>
  )
}
